import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../context/axios";

const ContactEnquiry = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const res = await axios.get("/contact-enquiries");
        setEnquiries(res.data || []);
      } catch (err) {
        setError("Failed to load enquiries");
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiries();
  }, []);

  if (loading) return <p className="text-center py-10 text-indigo-600">Loading enquiries...</p>;
  if (error) return <p className="text-red-500 text-center py-10">{error}</p>;

  return (
    <div className="min-h-screen py-2 px-2 ">
      <div className="max-w-7xl mx-auto p-6  rounded-lg ">
        <h2 className="text-4xl font-extrabold  text-indigo-600 mb-8">
          User Contact Enquiries
        </h2>
        {enquiries.length === 0 ? (
          <p className="text-gray-600 text-center">No enquiries found.</p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
          <table className="min-w-full text-sm bg-white">
  <thead className="bg-indigo-50 text-indigo-600">
    <tr>
      <th className="py-3 px-4 text-center">Sr No.</th>
      <th className="py-3 px-6 text-left">Name</th>
      <th className="py-3 px-6 text-left">Email</th>
      <th className="py-3 px-6 text-left">Mobile</th>
      <th className="py-3 px-6 text-left">Message</th>
      <th className="py-3 px-6 text-left">Date</th>
    </tr>
  </thead>
  <tbody>
    {enquiries.map((enquiry, index) => (
      <tr
        key={enquiry._id}
        className="hover:bg-indigo-50 transition-colors"
      >
        <td className="border-t px-4 py-3 text-center text-gray-800">
          {index + 1}
        </td>
        <td className="border-t px-4 py-3 text-gray-800">{enquiry.name}</td>
        <td className="border-t px-4 py-3 text-gray-800">{enquiry.email}</td>
        <td className="border-t px-4 py-3 text-gray-800">{enquiry.mobile}</td>
        <td className="border-t px-4 py-3 text-gray-800 max-w-xs truncate">
          {enquiry.message}
        </td>
        <td className="border-t px-4 py-3 text-gray-500">
          {new Date(enquiry.createdAt).toLocaleDateString()}
        </td>
      </tr>
    ))}
  </tbody>
</table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactEnquiry;
